import { FC, useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import Dropdown from "react-bootstrap/Dropdown";
import { string } from "yup";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchStateData, patchLogOut } from "../../redux/actions/dataActions";

const Header: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  function getInitials(fullName: string): string {
    const nameParts = fullName.split(" ");

    const initials = nameParts
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
    return initials;
  }

  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "";
  const initials = getInitials(username);

  useEffect(() => {
    const interval = setInterval(() => {
      HandelLogoutChange();
    }, 1 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const HandelLogoutChange = async () => {
    dispatch(
      patchLogOut((response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          console.log(response);
        }
      })
    );
  };

  const Logout = async () => {
    dispatch(
      patchLogOut((response: any) => {
        if (response.statusCode == 1) {
          localStorage.clear();
          navigate("/login");
        }
      })
    );
  };

  return (
    <>
      <header className="header">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo">
            <NavLink to="/dashboard">
              <img alt="" src={Logo} />
            </NavLink>
          </div>
          <div>
            <Dropdown align="end" className="acLink">
              <Dropdown.Toggle className="d-flex align-items-center">
                <span className="icon d-inline-flex align-items-center justify-content-center">
                  {initials}
                </span>
                {username}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#">{username}</Dropdown.Item>
                <Dropdown.Item onClick={Logout}>Sign Out</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
